export default __webpack_public_path__ + "static/media/1A29DE55-FC7C-4A69-804E-AD6D100165A9_1_105_c.b195d20a.jpeg";